import { render, staticRenderFns } from "./PphMix.vue?vue&type=template&id=0004ee84&scoped=true"
import script from "./PphMix.vue?vue&type=script&lang=js"
export * from "./PphMix.vue?vue&type=script&lang=js"
import style0 from "./PphMix.vue?vue&type=style&index=0&id=0004ee84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004ee84",
  null
  
)

export default component.exports